import { render, staticRenderFns } from "./RecetasEditFormComponent.vue?vue&type=template&id=6958e22c&scoped=true&"
import script from "./RecetasEditFormComponent.vue?vue&type=script&lang=js&"
export * from "./RecetasEditFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./RecetasEditFormComponent.vue?vue&type=style&index=0&id=6958e22c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6958e22c",
  null
  
)

export default component.exports